import React, { useEffect, useState } from "react";

const AddNewRole = ({
  roleData,
  setRoleData,
  roleAlreadydData,
  error,
  setError,
}) => {
  const [roles, setRoles] = useState([]);
  const [inputValue, setInputValue] = useState(roleData || "");
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Extract only role names
  const getRoleNames = (data) => data.map((item) => item.roleName);

  useEffect(() => {
    const roleList = getRoleNames(roleAlreadydData);
    setRoles(roleList);
  }, [roleAlreadydData]);

  const handleAddRole = () => {
    const trimmedRole = inputValue.trim();
    // if (!trimmedRole) {
    //   setError("Please enter a valid role name.");
    //   return;
    // }

    const exists = roles.some(
      (r) => r.toLowerCase() === trimmedRole.toLowerCase()
    );

    if (exists) {
      setError(`Role "${trimmedRole}" already exists.`);
      return;
    }

    setRoles((prev) => [...prev, trimmedRole]);
    setRoleData(trimmedRole);
    setInputValue(trimmedRole);
    setError("");
    setShowSuggestions(false);
  };

  const filteredRoles = roles.filter((r) =>
    r.toLowerCase().includes(inputValue.toLowerCase())
  );

  const roleExists = roles.some(
    (r) => r.toLowerCase() === inputValue.trim().toLowerCase()
  );

  return (
    <div className="relative space-y-2 p-4">
      <label className="block form_label_color pb-2">
        Role<span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        value={inputValue}
        onChange={(e) => {
          const value = e.target.value;
          setInputValue(value);
          setShowSuggestions(true);

          // Check if role already exists
          const exists = roles.some(
            (r) => r.toLowerCase() === value.trim().toLowerCase()
          );

          if (exists) {
            setError(`Role "${value.trim()}" already exists.`);
          } else {
            setError("");
            setRoleData(value);
          }
        }}
        onFocus={() => setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
        className="border border_color text-base rounded-lg block w-full p-2.5 h-12"
      />

      {showSuggestions && (
        <ul className="absolute z-10 w-[95%] bg-white border border-gray-300 rounded-lg mt-1 max-h-40 overflow-auto shadow-md">
          {filteredRoles.length > 0
            ? filteredRoles.map((role, index) => (
                <li
                  key={index}
                  className="px-4 py-2 text-gray-400 bg-gray-50 cursor-not-allowed"
                >
                  {role}
                </li>
              ))
            : !roleExists &&
              inputValue.trim() && (
                <li
                  className="px-4 py-2 text-[#373737] cursor-pointer hover:bg-blue-50 flex"
                >
                 
                 Adding “{inputValue}”
                </li>
              )}
        </ul>
      )}

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default AddNewRole;
